<script>
import api from "@services/api";

export default {
  props: {
    table: {
      type: String,
      default: ""
    },
    editable: {
      type: Boolean,
      default: false
    },
    copy: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    item: {},
    showModalDelete: false,
    editForm: false,
    hasSuccess: false,
    loadedUpdate: false,
    sendBack: true
  }),
  created() {
    this.$store.dispatch("alert/clear");
    this.editForm = this.editable;
    if (this.$route.params.id) {
      this.get(this.$route.params.id);
    }
  },
  mounted() {
    this.$helper.setLabelRequired();
  },
  computed: {
    alert() {
      return this.$store.state.alert;
    }
  },
  methods: {
    get(id) {
      api.get(`crud/${this.table}/${id}`).then(response => {
        this.item = response.data["data"];
        this.loadedUpdate = true;
        if (this.copy === true) {
          this.item.id = null;
          this.editForm = true;
        }
      });
    },
    edit() {
      this.editForm = true;
    },
    remove() {
      this.showModalDelete = true;
    },
    cancelRemove() {
      this.showModalDelete = false;
    },
    confirmRemove() {
      if (this.item.id) {
        api.delete(`crud/${this.table}/${this.item.id}`).then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.back();
          }
        });
        this.selectedId = null;
        this.showModalDelete = false;
      }
    },
    beforeSave() {},
    save() {
      this.beforeSave();

      // update
      if (this.item.id) {
        api.put(`crud/${this.table}`, this.item).then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.hasSuccess = true;
            this.back();
          }
        });
      }
      // insert
      else {
        api.post(`crud/${this.table}`, this.item).then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.hasSuccess = true;
            this.back();
          }
        });
      }
    },
    callCopy() {
      this.copy = true;
      this.item.id = null;
      this.editForm = true;
    },
    hasHistory() {
      return window.history.length > 2;
    },
    back() {
      if (!this.sendBack) return;
      if (this.hasHistory()) {
        this.$router.go(-1);
      } else {
        this.$router.push(
          this.$route.query.redirectFrom || {
            path: `/${this.table}`
          }
        );
      }
    }
  }
};
</script>
